import React, { useContext, useEffect } from 'react';
import LeadContext from '../../../Portfolio/subrouters/Buyer/providers/Lead/Lead.context';
import MessagingRouter from '../../Messaging.router';
import MessagingProvider from '../../providers/Messaging';
import { useLockScrollOnReroute } from 'hooks/useLockScrollOnReroute';
import HelmetWrapper from 'components/HelmetWrapper';

const MessagingBuyerWrapper: React.FC = () => {
  const { dealRoom, listing, unreadMessagesCount, updateUnreadMessagesCount } =
    useContext(LeadContext);

  useLockScrollOnReroute();

  useEffect(() => {
    if (unreadMessagesCount) updateUnreadMessagesCount(0);
  }, [unreadMessagesCount, updateUnreadMessagesCount]);

  return (
    <MessagingProvider
      listingId={listing?._id}
      dealRoomId={listing?.dealRoomId}
      listingEnquiryId={listing?.listingEnquiryId}
    >
      <HelmetWrapper title={`Chat - ${dealRoom?.portfolioName}`} />
      <MessagingRouter />
    </MessagingProvider>
  );
};

export default MessagingBuyerWrapper;
